/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {generateSchedule} from '../api'

export const useMutationGenerateSchedule = createReactQueryMutationHook('generateSchedule', generateSchedule)
